import { Elements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import { FormikProps } from "formik"
import React, { Dispatch } from "react"

import { CartItemDetailsType } from "@modules/tenants/OrdersPage/Components/AddOrderModal"
import { ValidateGiftcardCodeResponseType, depositType } from "@mono/essentials/types/CartTypes"
import {
  CustomerTypeOrder,
  PayOrderRequestType,
  GetOrderDetailsResponseType,
} from "@mono/essentials/types/OrderTypes"

import { PaymentAmountDetails } from "../PaymentModal"

import StripeCreditCardForm, { StripeCreditCardFormAttributes } from "./StripeCreditCardForm"

interface StripeCreditCardProps {
  handleClose: () => void
  onSuccess?: (orderId: string) => void
  stripeKey: string
  stripeAccountId: string
  isModal?: boolean
  hasDepositData?: depositType | undefined
  stripeCreditCardFormRef?: React.RefObject<FormikProps<StripeCreditCardFormAttributes>>
  hideDefaultContainer?: boolean
  cartId?: string
  orderId?: string
  stripePaymentId: string
  isIntegratedPage?: boolean
  onOrderCreation?: (orderData?: GetOrderDetailsResponseType) => void
  cartDetails?: CartItemDetailsType
  refetchCartData?: () => void
  paymentAmountDetails?: PaymentAmountDetails
  goToPrevStep?: () => void
  onError?: () => void
  hideBackButton?: boolean
  payOrderTipDetails?: PayOrderRequestType["tip"]
  onlyTipPayment?: boolean
  customer?: CustomerTypeOrder
  handleSubmit?: (arg0: StripeCreditCardFormAttributes, paymentToken: string) => Promise<void>
  hideSavedCards?: boolean
  isPublicPayment?: boolean
  isWidgetsCard?: boolean
  giftcardDetails?: ValidateGiftcardCodeResponseType["giftcard"]
  isAuthUser?: boolean
  showPendingBookingPaymentConfirmation?: (arg0: boolean) => void
  handlePaymentConfirmation?: boolean
  handleCustomerRebookDuePayment?: (payload: PayOrderRequestType) => Promise<void>
}

const StripeCreditCard = ({
  handleClose,
  onSuccess,
  stripeKey,
  stripeCreditCardFormRef,
  hideDefaultContainer,
  cartId,
  stripePaymentId,
  isIntegratedPage,
  onOrderCreation,
  cartDetails,
  refetchCartData,
  goToPrevStep,
  paymentAmountDetails,
  onError,
  hideBackButton,
  orderId,
  payOrderTipDetails,
  onlyTipPayment = false,
  customer,
  handleSubmit,
  isWidgetsCard = false,
  hideSavedCards = false,
  isPublicPayment = false,
  giftcardDetails,
  isAuthUser = true,
  showPendingBookingPaymentConfirmation,
  handlePaymentConfirmation = false,
  handleCustomerRebookDuePayment,
}: StripeCreditCardProps) => {
  const stripePromise = loadStripe(stripeKey, {})

  return (
    <Elements options={{}} stripe={stripePromise}>
      <StripeCreditCardForm
        onSuccess={onSuccess}
        handleClose={handleClose}
        stripeCreditCardFormRef={stripeCreditCardFormRef}
        hideDefaultContainer={hideDefaultContainer}
        cartId={cartId}
        stripePaymentId={stripePaymentId}
        isIntegratedPage={isIntegratedPage}
        onOrderCreation={onOrderCreation}
        cartDetails={cartDetails}
        refetchCartData={refetchCartData}
        paymentAmountDetails={paymentAmountDetails}
        goToPrevStep={goToPrevStep}
        onPaymentError={onError}
        hideBackButton={hideBackButton}
        orderId={orderId}
        payOrderTipDetails={payOrderTipDetails}
        onlyTipPayment={onlyTipPayment}
        customer={customer}
        handleSubmit={handleSubmit}
        hideSavedCards={hideSavedCards}
        isPublicPayment={isPublicPayment}
        giftcardDetails={giftcardDetails}
        isWidgetsCard={isWidgetsCard}
        isAuthUser={isAuthUser}
        showPendingBookingPaymentConfirmation={showPendingBookingPaymentConfirmation}
        handlePaymentConfirmation={handlePaymentConfirmation}
        handleCustomerRebookDuePayment={handleCustomerRebookDuePayment}
      />
    </Elements>
  )
}

export default StripeCreditCard
